import { omit } from 'lodash';
import 'react-hot-loader/patch';
import './polyfills';
import { syncHistoryWithStore } from 'react-router-redux';
import 'reset-css';

import rootReducer from './reducers';
import { fetchAndSetSitePages } from './actions/fetch-and-set-site-pages';
import { setSiteInfo } from './actions/set-site-info';
import { storeCreated } from './actions/store-created';
import Root from './containers/root';
import { isInPostPreview } from './selectors/location-history-selectors';
import { getIsIphone } from './selectors/user-agent-selectors';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import { parseGetParam } from './services/parse-get-param';
import { replace } from './services/router-utils';
import Wix from './services/wix-sdk-polyfill';
import createBrowserHistory from './services/create-browser-history';
import { initClientI18n } from '@wix/communities-blog-client-common/dist/src/services/i18n-utils';
import configureStore from './store/configureStore';
import { debug } from './services/debug';
import renderApp from './bootstrap/render-app';
import storeHooks from './bootstrap/store-hooks';
import getMiddleware from './bootstrap/middleware';
import { usersEventMap } from './app-users-events';

const browserHistory = createBrowserHistory();
const config = window.__CONFIG__;
const initialState = window.__INITIAL_STATE__ || {};
const i18n = initClientI18n();
const middlewares = getMiddleware({
  config,
  experiments: initialState.experiments,
  i18n,
  browserHistory,
  isOneApp: isOneApp(initialState),
  isIphone: getIsIphone(initialState),
  isInPostPreview: isInPostPreview(initialState),
  usersEventMap,
});
const store = configureStore(omit(initialState, ['textEditor']), middlewares, rootReducer);
const history = syncHistoryWithStore(browserHistory, store);

store.dispatch(storeCreated());
store.dispatch(fetchAndSetSitePages());

dispatchSiteInfo();

storeHooks(store, history);

redirectIfNeeded();

renderApp(Root, store, history, i18n);

setupHotModuleReplacementIfEnabled();

function dispatchSiteInfo() {
  Wix.getSiteInfo(data => {
    store.dispatch(setSiteInfo(data));
  });
}

function setupHotModuleReplacementIfEnabled() {
  if (module.hot) {
    module.hot.accept('./containers/root', () => {
      debug.log('HOT RELOAD START');
      // While using 'separateCss: true', external css files must be manually reloaded
      document.querySelectorAll('link[href][rel=stylesheet]').forEach(link => {
        const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
        link.href = nextStyleHref;
      });
      renderApp(require('./containers/root').default, store, history, i18n);
      debug.log('HOT RELOAD END');
    });
  }
}

function redirectIfNeeded() {
  let lastLocation = {};
  history.listen(location => (lastLocation = location));

  const redirect = parseGetParam('redirect');
  if (redirect) {
    store.dispatch(replace(`${lastLocation.pathname}?redirect=${redirect}`));
  }
}
